import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, mapTo, mergeMapTo } from 'rxjs/operators';
import { NotificationType } from '@app/core/state/core.model';
import { ResetService } from '../services/reset.service';
import * as actions from './reset.actions';
import { authRedirectAfterLogin } from '@app/auth/core/state/auth.actions';
import { notificationSend } from '@app/core/state/core.actions';

@Injectable()
export class ResetEffects {
  resetPassword$ = createEffect(() => {
    return this.actions$.pipe(
      ofType<actions.ResetPassword>(actions.ActionTypes.RESET_PASSWORD),
      map(action => {
        return action.payload;
      }),
      exhaustMap(payload => {
        return this.resetService.resetPassword$(payload).pipe(
          mapTo(new actions.ResetPasswordSuccess()),
          catchError(({ error }: HttpErrorResponse) => {
            try {
              const parsedError = JSON.parse(error);

              return of(new actions.ResetPasswordFailure(parsedError.message || parsedError));
            } catch (e) {
              return of(new actions.ResetPasswordFailure(error.message || error));
            }
          }),
        );
      }),
    );
  });

  resetPasswordSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actions.ActionTypes.RESET_PASSWORD_SUCCESS),
      mergeMapTo([
        authRedirectAfterLogin({ path: '' }),
        notificationSend({
          message: $localize`:@@ts.reset.success:Password saved`,
          notificationType: NotificationType.SUCCESS,
        }),
      ]),
    );
  });

  constructor(private actions$: Actions, private resetService: ResetService) {}
}
